import { owner_roles } from '../data/data';

export default {
    "items": [
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "full-name",
                    "width": 0,
                    "props": {
                        "label": "Prefix",
                        "hidden": true,
                        "formula": {
                            "name": "join",
                            "arguments": {
                                "targets": [
                                    "first-name",
                                    "last-name"
                                ]
                            }
                        }
                    }
                },
                {
                    "type": "text-field",
                    "name": "prefix",
                    "width": 2,
                    "props": {
                        "label": "Prefix"
                    }
                },
                {
                    "type": "text-field",
                    "name": "first-name",
                    "width": 5,
                    "props": {
                        "label": "First Name"
                    }
                },
                {
                    "type": "text-field",
                    "name": "last-name",
                    "width": 5,
                    "props": {
                        "label": "Last Name"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "selectlist",
                    "name": "title",
                    "width": 5,
                    "props": {
                        "items": [],
                        "label": "Title"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "selectlist",
                    "name": "related-to-owner",
                    "width": 4,
                    "props": {
                        "items": [
                            {
                                "text": "Yes",
                                "value": "yes"
                            },
                            {
                                "text": "No",
                                "value": "no"
                            }
                        ],
                        "label": "Related to Owner?"
                    }
                },
                {
                    "type": "selectlist",
                    "name": "role",
                    "width": 5,
                    "props": {
                        "items": "owner_roles",
                        "label": "Role"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "ownership-percentage",
                    "width": 4,
                    "props": {
                        "format": "percent",
                        "label": "Ownership %"
                    }
                },
                {
                    "type": "text-field",
                    "name": "hours",
                    "width": 4,
                    "props": {
                        "format": "number",
                        "label": "Hours / Week"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "designations",
                    "width": 6,
                    "props": {
                        "label": "Designations (should be separated by commas)"
                    }
                },
                {
                    "type": "text-field",
                    "name": "securities-licensed",
                    "width": 6,
                    "props": {
                        "label": "Securities Licensed (should be separated by commas)"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "checkbox-list",
                    "name": "insurance-licenses",
                    "width": 12,
                    "props": {
                        "label": "Insurance Licenses",
                        "row": true,
                        "items": [
                            {
                                "text": "Health",
                                "value": "health"
                            },
                            {
                                "text": "Life",
                                "value": "life"
                            },
                            {
                                "text": "Disability",
                                "value": "disability"
                            },
                            {
                                "text": "Annuity",
                                "value": "annuity"
                            },
                            {
                                "text": "LTC",
                                "value": "ltc"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "years-licensed",
                    "width": 4,
                    "props": {
                        "format": "number",
                        "label": "Years Licensed"
                    }
                },
                {
                    "type": "selectlist",
                    "name": "compliance-record",
                    "width": 8,
                    "props": {
                        "label": "Compliance Record",
                        "items": [
                            {
                                "text": "Yes, there are disclosure events",
                                "value": "yes"
                            },
                            {
                                "text": "No, advisor has a clean record",
                                "value": "no"
                            }
                        ]
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "annual-salary",
                    "width": 6,
                    "props": {
                        "label": "Annual Salary",
                        "format": "dollars"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "annual-bonus",
                    "width": 6,
                    "props": {
                        "label": "Annual Bonus",
                        "format": "dollars"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "gdc",
                    "width": 6,
                    "props": {
                        "label": "Wages paid on % of GDC",
                        "format": "dollars"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "annual-distribution",
                    "width": 6,
                    "props": {
                        "label": "Annual Draw/Distribution",
                        "format": "dollars"
                    }
                }
            ]
        },
        {
            "type": "inline",
            "items": [
                {
                    "type": "text-field",
                    "name": "annual-benefits",
                    "width": 6,
                    "props": {
                        "label": "Amount of Annual Owner Benefits",
                        "format": "dollars"
                    }
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/data_table_forms/owner.js